import { OverlayPanel } from "primereact/overlaypanel";
import styled from "styled-components";

// Each order row is drawn as a card, and the expanded details panel is the
// bottom half of one, so the table and the panel both need these.
export const ROW_RADIUS = 16;
export const ROW_GAP = 12;

export const FilterTriggerStyled = styled.button`
  cursor: pointer;

  /* Matches the vertical padding of .p-inputtext / .p-multiselect-label so the
     trigger is exactly as tall as the neighbouring filters. */
  padding: 0.75rem 1rem;

  border: 1px solid var(--brand-gray-200);
  border-radius: 12px;
  background-color: var(--brand-white);

  color: var(--brand-gray-600);
  font-family: var(--font-family);
  font-size: 0.875rem;

  box-shadow: 0 1px 2px color-mix(in srgb, var(--brand-black) 5%, transparent),
    0 2px 6px color-mix(in srgb, var(--brand-black) 6%, transparent);

  &:hover {
    background-color: var(--brand-gray-50);
  }

  &:focus-visible {
    outline: 2px solid var(--brand-purple-600);
    outline-offset: 2px;
  }
`;

export const FilterValueStyled = styled.span`
  color: var(--brand-gray-700);
  font-weight: var(--font-weight-semibold);
`;

export const FilterPanelStyled = styled(OverlayPanel)`
  border-radius: 16px;

  .p-overlaypanel-content {
    padding: 1.25rem;
  }

  &::before,
  &::after {
    display: none;
  }
`;
